import { message } from 'antd'
import { EnquiriesApi } from '../../../../api/Sales/Enquiries'
import EnquiriesLines from '../../../../components/Sales/Enquiries/Lines/EnquiriesLines'
import useFetchList from '../../../../elements/Hooks/useFetchList'
import useFetchObject from '../../../../elements/Hooks/useFetchObject'
import useModalData from '../../../../elements/Hooks/useModalData'
import { get, isEmpty } from 'lodash'
import React from 'react'

function EnquiriesLinesCont (props) {
  const { enquiry } = props
  const isNew = isEmpty(enquiry)
  const { list, fetching, fetch } = useFetchList(() => EnquiriesApi.getLinesByEnquiry(enquiry._key))

  const isExistingClient = !!get(enquiry, 'isExistingClient')
  const contractKey = get(enquiry, 'contract._id', '').replace('salesContracts', '')
  const { object: salesContracts } = useFetchObject(
    () => EnquiriesApi.getSaleContract(contractKey),
    false,
    [contractKey],
    isEmpty(contractKey),
  )

  let company = get(isExistingClient ? salesContracts : enquiry, 'company')

  const {
    visible,
    modalType,
    object: line,
    submitting,
    setSubmitting,
    removing,
    remove,
    formRef,
    onShow,
    onCancel,
    checkForm,
    update,
  } = useModalData(undefined, EnquiriesApi.lines.update, EnquiriesApi.lines.remove, fetch)

  async function submit () {
    const newObject = await checkForm()
    newObject.rate = `${newObject.rate !== undefined && true ? newObject.rate : 0}`
    setSubmitting(true)
    try {
      await EnquiriesApi.lines.create({ ...newObject, enquiry })
      onCancel()
      fetch()
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  return (
    <EnquiriesLines
      {...{
        list,
        fetching,
        fetch,
        visible,
        submitting,
        enquiry,
        line,
        onShow,
        onCancel,
        checkForm,
        submit,
        removing,
        remove,
        update,
        modalType,
        formRef,
        company,
        isNew
      }}
    />
  )
}

EnquiriesLinesCont.propTypes = {}
EnquiriesLinesCont.defaultProps = {}

export default (EnquiriesLinesCont)
